import React, { useState } from "react";
import "./CategoryModal.css";

export default function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) return setError("New passwords don't match");
    if (next.length < 8) return setError("New password must be at least 8 characters");
    setLoading(true);
    try {
      const res = await fetch("/api/auth/change-password", {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || "Failed to change password");
      setSuccess(true);
    } catch {
      setError("Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3>Change Password</h3>
        {success ? (
          <>
            <p className="modal-subtext" style={{ color: "var(--priority-low)" }}>Password updated successfully.</p>
            <div className="modal-actions">
              <button className="btn-confirm" onClick={onClose}>Done</button>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="modal-field">
              <label>Current password</label>
              <input type="password" value={current} onChange={e => setCurrent(e.target.value)} autoFocus autoComplete="current-password" />
            </div>
            <div className="modal-field">
              <label>New password</label>
              <input type="password" value={next} onChange={e => setNext(e.target.value)} autoComplete="new-password" />
            </div>
            <div className="modal-field">
              <label>Confirm new password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" />
            </div>
            {error && <p className="modal-subtext" style={{ color: "var(--accent)" }}>{error}</p>}
            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn-confirm" disabled={loading}>{loading ? "Saving…" : "Update"}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
